import React from 'react';
import { connect, useDispatch } from 'react-redux';
import 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';

import _isEmpty from 'lodash/isEmpty';
import _includes from 'lodash/includes';
import _get from 'lodash/get';
import { getRefDataEventMonitoringRecords } from 'service/refdata/eventconfiguration/action';
import { gridOptions } from './constants';
import { Label } from 'reactstrap';

const EventLockGrid = ({ widgetEvent }) => {
    const dispatch = useDispatch();
    const [gridApi, setGridApi] = React.useState(null);
    const [gridColumnApi, setGridColumnApi] = React.useState(null);
    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    React.useEffect(() => {
        dispatch(getRefDataEventMonitoringRecords(10));
    }, []);

    const columnDefs = [
        {
            headerName: 'Event',
            field: 'event_monitor_id',
            editable: false,
            width: 100,
        },
        {
            headerName: 'Time',
            field: 'start_time',
            editable: false,
            width: 180,
        },
    ];

    return (
        <div className={'container-fluid'}>
            <div className={'row'}>
                <div className={'col-md-12 mt-5'}>
                    <Label style={{ color: '#4BB3BC' }}>Last Events</Label>
                    <div
                        id="myGrid"
                        style={{
                            height: '25vh',
                        }}
                        className={parseInt(localStorage.getItem('theme')) ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'}
                    >
                        <AgGridReact
                            suppressDragLeaveHidesColumns
                            columnDefs={columnDefs}
                            defaultColDef={gridOptions.defaultColDef}
                            enableRangeSelection={gridOptions.enableRangeSelection}
                            allowContextMenuWithControlKey={gridOptions.allowContextMenuWithControlKey}
                            rowData={widgetEvent}
                            animateRows={gridOptions.animateRows}
                            rowDragMultiRow
                            rowSelection
                            onGridReady={onGridReady}
                            rowDragManaged
                            enableCellSelect
                            rowHeight={25}
                            cacheBlockSize={100000}
                            // getContextMenuItems={getContextMenuItems}
                            paginationPageSize={10000}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ refDataReducer }) => ({
    widgetEvent: refDataReducer.eventConfigurationReducer.widgetEvent,
});
export default connect(mapStateToProps)(EventLockGrid);
